"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPreview = void 0;

var _VideoPlayer = require("../../VideoPlayer");

var _molecules = require("../../../molecules");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Drew Burnett
 */
// Imports
// VideoPreview
var VideoPreview = function VideoPreview(_ref) {
  var moment = _ref.moment,
      updates = _ref.updates,
      duration = _ref.duration,
      containerRef = _ref.containerRef,
      startAtOverride = _ref.startAtOverride,
      stopAtOverride = _ref.stopAtOverride,
      mainVideoCallbackRef = _ref.mainVideoCallbackRef,
      freeze = _ref.freeze;

  var _useVideoInfo = (0, _VideoPlayer.useVideoInfo)(containerRef),
      currentTime = _useVideoInfo.currentTime;

  var startAt = startAtOverride ? startAtOverride : updates.startAtRelative;
  var stopAt = stopAtOverride ? stopAtOverride : updates.stopAtRelative;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_VideoPlayer.VideoPlayer, {
    containerRef: containerRef,
    noMulticam: true,
    moment: moment,
    startAt: startAt,
    stopAt: stopAt,
    mainVideoCallbackRef: mainVideoCallbackRef,
    freeze: freeze,
    muted: true,
    loop: true
  }), /*#__PURE__*/_react.default.createElement(_molecules.ProgressBar, {
    className: "upload-moment-preview-progress-bar",
    background: "transparent-color",
    value: currentTime - startAt,
    total: duration,
    width: "100%",
    opacity: 1
  }));
};

exports.VideoPreview = VideoPreview;
VideoPreview.defaultProps = {
  mainVideoCallbackRef: null,
  freeze: false
};